import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@react-hook/media-query';
import PDFPreview from '../PDFPreview';
import { SmartLink } from '../SmartLink';

import style from './DownloadComponents.module.scss';

export const DownloadCard = ({ image, mobileImage, title, description, cta, disablePdfPreview, pdfPageOrientation }) => {
    const isMobile = useMediaQuery('only screen and (max-width: 650px)');
    const isPdf = cta?.link?.url?.endsWith('.pdf');

    if (!isPdf || disablePdfPreview) {
        return (
            <div className={style.download}>
                <div className={`${style.treasersCard} ${image?.url ? '' : style.noImage}`}>
                    {image?.url && (
                        <div className={style.treaserImageBox}>
                            <img src={isMobile ? mobileImage?.url : image.url} alt={image.alt} />
                        </div>
                    )}
                    <div className={style.treaserCopy}>
                        <div className={style.treaserTitle}>
                            <p>{title}</p>
                        </div>
                        <div className={style.treaserDescription}>
                            <h3>{description}</h3>
                        </div>
                        <div className={style.treaserCta}>
                            <SmartLink href={cta.link.url}>{cta.text}</SmartLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <PDFPreview
                title={title}
                cta={cta}
                pdfPageOrientation={pdfPageOrientation}
            />
        );
    }
};

export const DownloadCardContent = ({ title, downloadContent }) => {
    return (
        <div className={style['article-text']}>
            {title && <h4>{title}</h4>}
            <div dangerouslySetInnerHTML={{ __html: downloadContent }} />
        </div>
    );
};

DownloadCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.object,
    image: PropTypes.object,
    mobileImage: PropTypes.object,
    disablePdfPreview: PropTypes.bool,
    pdfPageOrientation: PropTypes.string
};

DownloadCardContent.propTypes = {
    title: PropTypes.string,
    downloadContent: PropTypes.string
};
